// src/components/FloatingActions.js
import React from "react";
import { getAttributionReference } from "../analytics/attribution";
import { trackContact, trackPhoneClick, trackWhatsAppClick } from "../analytics/analytics";

export function formatFloorForWhatsApp(selectedFloor) {
  const floor = String(selectedFloor || "").trim();
  const numberedLevel = floor.match(/^L(\d+)$/i);
  return numberedLevel ? numberedLevel[1] : floor;
}

export function buildWhatsAppUrl(phone, lang, selectedFloor) {
  const floor = formatFloorForWhatsApp(selectedFloor);
  const inquiry = floor
    ? `مرحباً، أود الاستفسار عن مشروع GRANADA والطابق ${floor} والأسعار المتاحة.`
    : "مرحباً، أود الاستفسار عن مشروع GRANADA والأسعار المتاحة.";
  const message = `${inquiry}\nالمرجع: ${getAttributionReference()}`;
  return `https://wa.me/${phone.replace(/[^\d]/g, "")}?text=${encodeURIComponent(message)}`;
}

export default function FloatingActions({
  phone = "+970000000000",
  lang = "en",
  route = "#home",
  selectedFloor = "",
  bottom = "calc(env(safe-area-inset-bottom, 0px) + 18px)",
}) {
  const whatsapp = buildWhatsAppUrl(phone, lang, selectedFloor);
  const label = lang === "ar" ? "اتصل / واتساب" : "Call / WhatsApp";
  const eventContext = { route, cta_location: "floating_actions", selected_floor: selectedFloor || undefined };

  return (
    <div
      aria-label={label}
      style={{
        position: "fixed",
        left: 18,                // ⬅️ move to left side
        right: "auto",
        bottom,
        display: "flex",
        gap: 8,
        zIndex: 45,             // below AI (60) and sponsor (1000), above page content
        pointerEvents: "auto",
      }}
    >
      <a
        href={`tel:${phone}`}
        onClick={() => {
          trackPhoneClick(eventContext);
          trackContact({ ...eventContext, channel: "phone" });
        }}
        style={{
          background: "#fff",
          border: "1px solid #e6e8eb",
          borderRadius: 999,
          padding: "10px 14px",
          textDecoration: "none",
          color: "#111",
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
          fontSize: 13,
          fontWeight: 600,
          backdropFilter: "saturate(120%) blur(6px)",
          WebkitBackdropFilter: "saturate(120%) blur(6px)",
        }}
      >
        {lang === "ar" ? "اتصال" : "Call"}
      </a>
      <a
        href={whatsapp}
        onClick={() => {
          trackWhatsAppClick(eventContext);
          trackContact({ ...eventContext, channel: "whatsapp" });
        }}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          background: "#25D366",
          border: "1px solid #1aae53",
          borderRadius: 999,
          padding: "10px 14px",
          textDecoration: "none",
          color: "#fff",
          boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
          fontSize: 13,
          fontWeight: 600,
        }}
      >
        WhatsApp
      </a>
    </div>
  );
}
